import { useQuery } from '@tanstack/react-query';

import { rotationsInfoKeys } from '@/hooks/tie-breaker/rotationsInfoKeys';
import { getLastSequencesInfo } from '@/infrastructure/network/data/tiebreaker/tie-breaker';

export const useLastSequenceInfoQuery = (matchId: string, gameNumber: number) => {
	return useQuery({
		queryKey: rotationsInfoKeys.lastSequenceInfo(matchId, gameNumber),
		queryFn: () => getLastSequencesInfo({ matchUuid: matchId, gameNumber }),
		enabled: !!matchId && !!gameNumber
	});
};
